import React from 'react';
// src/components/ui/Alert.tsx
// Inline alert banner (STYLEGUIDE §5 alert treatment) — the styled replacement
// for ad-hoc coloured divs and for surfacing form/page errors.

import { InfoIcon, CheckCircleIcon, AlertTriangleIcon, XCircleIcon } from 'lucide-react';

export type AlertTone = 'info' | 'ok' | 'warn' | 'danger';

const cfg: Record<AlertTone, { bg: string; border: string; fg: string; Icon: React.ComponentType<{ className?: string }> }> = {
  info: { bg: 'bg-info-bg', border: 'border-info-border', fg: 'text-info-fg', Icon: InfoIcon },
  ok: { bg: 'bg-ok-bg', border: 'border-ok-border', fg: 'text-ok-fg', Icon: CheckCircleIcon },
  warn: { bg: 'bg-warn-bg', border: 'border-warn-border', fg: 'text-warn-fg', Icon: AlertTriangleIcon },
  danger: { bg: 'bg-danger-bg', border: 'border-danger-border', fg: 'text-danger-fg', Icon: XCircleIcon },
};

interface AlertProps {
  tone?: AlertTone;
  title?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ tone = 'info', title, children, className = '' }) => {
  const { bg, border, fg, Icon } = cfg[tone];
  return (
    <div className={`flex gap-3 p-4 rounded-lg border ${bg} ${border} ${className}`} role={tone === 'danger' ? 'alert' : 'status'}>
      <Icon className={`h-[18px] w-[18px] flex-shrink-0 mt-0.5 ${fg}`} aria-hidden="true" />
      <div className={`text-body-sm ${fg}`}>
        {title && <p className="font-semibold mb-0.5">{title}</p>}
        {children && <div>{children}</div>}
      </div>
    </div>
  );
};

export default Alert;
